import { Button } from "@svea/design-system-components-react";
import { FormHelperText, P, SniInput, Stack, Text, useText } from "@sveabank/cc-common";
import { useState } from "react";
import { usePageContext } from "../../../../hooks/context";
import { stepIs } from "../../../../utils/application";
import { useKyc } from "../../hooks";

type Props = {
	onSubmit: (sniCodes: Array<string>) => Promise<void>;
};

const SniCodes = ({ onSubmit }: Props) => {
	const { allSniCodes, steps, isSubmittingSniCodes } = usePageContext(useKyc);
	const savedSniCodes = steps.find(stepIs("AssignSniCodesStep"))?.state.sniCodes || [];
	const [selectedCodes, setSelectedCodes] = useState<Array<string>>(savedSniCodes);
	const [error, setError] = useState(false);
	const [t, texts] = useText();

	const onAddClick = (sniCode: string) => {
		setSelectedCodes(
			!selectedCodes.includes(sniCode) ? [...selectedCodes, sniCode] : [...selectedCodes],
		);
		setError(false);
	};

	const onDeleteClick = (code: string) => {
		setSelectedCodes(selectedCodes.filter((c) => c !== code));
	};

	const onSubmitClick = async () => {
		if (selectedCodes.length < 1) {
			setError(true);
		} else {
			setError(false);
			await onSubmit(selectedCodes);
		}
	};

	return (
		<Stack gap={4} align="start">
			<P>{t(texts.kyc.sniCode.searchSni)}</P>
			<SniInput
				onAdd={onAddClick}
				onDelete={onDeleteClick}
				selectedCodes={selectedCodes}
				sniCodes={allSniCodes}
			/>

			<Stack align="end" justify="end" fullSize gap={2}>
				<Button onPress={onSubmitClick} isPending={isSubmittingSniCodes}>
					{t(texts.common.save)}
				</Button>
				<Text align="right">
					{error && <FormHelperText error>{t(texts.kyc.sniCode.required)}</FormHelperText>}
				</Text>
			</Stack>
		</Stack>
	);
};

export default SniCodes;
